export const heads = [
  { image: "/images/head/1.jpg" },
  { image: "/images/head/2.jpg" },
  { image: "/images/head/3.jpg" },
  { image: "/images/head/4.jpg" },
  { image: "/images/head/5.jpg" },
];
